import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    closeCancelAutoRenewConfirmDialog,
    renderCancelAutoRenewConfirmDialog,
} from 'reactApp/components/CancelAutoRenewConfirmDialog/CancelAutoRenewConfirmDialog.helpers';
import type { CheckOffer, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { isVkMusicSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';
import { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';
import {
    closeVkMusicCancelSubscriptionMobile,
    renderVkMusicCancelSubscriptionMobile,
} from 'reactApp/ui/VkMusic/VkMusicCancelSubscription/mobile/VkMusicCancelSubscriptionMobile/VkMusicCancelSubscriptionMobile.helpers';

export function checkVkMusicOffer({ subscription }: CheckOffer) {
    return isVkMusicSubscription(subscription);
}

const vkMusicTariff = 'vk-music-tariff';

export function* vkMusicOffer({ subscription, continueOutflow, cancelOutflow, sendAnalytics }: OutflowOfferWebProps) {
    yield renderCancelAutoRenewConfirmDialog({
        subscription,
        isVkMusic: true,
        isTrial: false,
        skipAnalytic: false,
        onShow() {
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelView, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_VIEW);
        },
        onAction() {
            closeCancelAutoRenewConfirmDialog();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelCancel, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_CANCEL);
            continueOutflow();
        },
        onClose() {
            closeCancelAutoRenewConfirmDialog();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelClose, vkMusicTariff);
            cancelOutflow();
        },
        onSuccess() {
            closeCancelAutoRenewConfirmDialog();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelSave, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_SAVE);
            cancelOutflow();
        },
    });
}

export function* vkMusicOfferMobile({ subscription, continueOutflow, cancelOutflow, sendAnalytics }: OutflowOfferWebProps) {
    yield renderVkMusicCancelSubscriptionMobile({
        subscription,
        onShow() {
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelView, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_VIEW);
        },
        onAction() {
            closeVkMusicCancelSubscriptionMobile();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelCancel, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_CANCEL);
            continueOutflow();
        },
        onClose() {
            closeVkMusicCancelSubscriptionMobile();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelClose, vkMusicTariff);
            cancelOutflow();
        },
        onSuccess() {
            closeVkMusicCancelSubscriptionMobile();
            sendAnalytics?.(ESubscriptionModalAction.vkMusicCancelSave, vkMusicTariff);
            emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_SAVE);
            cancelOutflow();
        },
    });
}
